import { Col, Input, Row } from "reactstrap"
import Toggle from "../../../../../components/common/Toggle/Toggle"
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const AutomatedReply = () => {
  const data = [
    { message: "Hello! How can I assist you today?", timesUsed: 5 },
    { message: "Hello! How can I assist you today?", timesUsed: 5 },
    { message: "We are processing your order", timesUsed: 5 },
    { message: "Hello! How can I assist you today?", timesUsed: 5 },
    { message: "We are processing your order", timesUsed: 5 },
  ]

  const columns = [
    { name: "Message", selector: (row) => row.message, grow: 3, wrap: true },
    { name: "Times Used", selector: (row) => row.timesUsed, grow: 1, wrap: true },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2">
          <span className="cursor-pointer">Edit</span>
          <span className="cursor-pointer">Remove</span>
        </div>
      ),
      grow: 1,
      wrap: true
    },
  ]

  return (
    <YellowHeaderWrapper title={"Automated Reply"}>
      <div className="fw-semibold fs-5">Auto-reply</div>
      <Row className="g-0 align-items-center">
        <Col xs="5" lg='2'>Welcoming Message:</Col>
        <Col>
          <Toggle />
        </Col>
      </Row>
      <Row className="g-0">
        <Col xs="5" lg='2'>Message Text:</Col>
        <Col>
          <Input type="textarea" />
        </Col>
      </Row>
      <Row className="g-0 align-items-center">
        <Col xs="5" lg='2'>When outside working hours:</Col>
        <Col>
          <Toggle />
        </Col>
      </Row>
      <Row className="g-0">
        <Col xs="5" lg='2'>Message Text:</Col>
        <Col>
          <Input type="textarea" />
        </Col>
      </Row>
      <Row className="g-0 align-items-center">
        <Col xs="5" lg='2'>When on holiday mode:</Col>
        <Col>
          <Toggle />
        </Col>
      </Row>
      <Row className="g-0">
        <Col xs="5" lg='2'>Message Text:</Col>
        <Col>
          <Input type="textarea" />
        </Col>
      </Row>

      <div className="fw-semibold fs-5">Quick Reply</div>
      <Row className="g-0 align-items-center">
        <Col xs="5" lg='2'>When on holiday mode:</Col>
        <Col>
          <Toggle />
        </Col>
      </Row>
      <Row className="g-0">
        <Col xs="5" lg='2'>Message Text:</Col>
        <Col>
          <Input type="textarea" />
        </Col>
      </Row>
      <Row className="g-0 align-items-center">
        <Col xs="5" lg='2'></Col>
        <Col className="d-flex justify-content-end">
          <PrimaryButton name={"Add"} />
        </Col>
      </Row>

      <div className="fw-semibold fs-5 mt-3">Quick Replies List</div>

      <DatatableComponent columns={columns} data={data} type={"gray"} />
    </YellowHeaderWrapper>
  )
}

export default AutomatedReply
